// @flow

import React from 'react';
import type {Element} from 'react';
import type {Show} from '../store';
import {connector} from '../store';
import ga from '../../../vendor/google-analytics';

function shouldDisplayUrl(url) {
  return url.search(/tpt\.org\//) === -1;
}

function trackExternal(show) {
  return function() {
    ga('send', 'event', 'Show | About', 'Click To External | [P]', [show.title, show.website_url].join(' | '));
  }
}

export function About({ show }: { show: Show}): Element<any> {
  return (
    <div className="show-details row full-row">
      <div className="small-12 columns">
        <div className="headline section-header" dangerouslySetInnerHTML={{__html: "About "+show.title}}/>
        <div dangerouslySetInnerHTML={{__html: show.description}}/>
        <div className="extra-show-data-wrapper">
          <p className="extra-show-data">
            {show.resourceLinks.DVD.length > 0 &&
            <a className="no-delay outline-btn" href={show.resourceLinks.DVD[0]}>
              Buy DVD
            </a>}
            {show.website_url && shouldDisplayUrl(show.website_url) &&
              <a className="no-delay outline-btn" href={show.website_url} onClick={trackExternal(show)}>
                {show.site_button_text || 'Visit Website'}
              </a>
            }
          </p>
        </div>
      </div>
    </div>
  );
}

export default connector(About);